import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';
import { analysisModel} from '../models/Accounting/tAnalysisModel';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NavigationComponent } from '../pages/navigation/navigation.component';


@NgModule({
    imports: [CommonModule, FormsModule]
})

@Injectable({
    providedIn: 'root'
})
export class tAnalysisService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tAnalysis';

    getAllData() {
        return this.http.get<analysisModel[]>(this.baseurl + this.pathName);
    }

    getGetDialog(searchCode:number){
        return this.http.get<analysisModel[]>(this.baseurl + this.pathName+'/'+'searchForDialog'+'/'+NavigationComponent.selectedShopID.toString()+'/'+searchCode);
    }

    getDataByID(aysID:number){
        return this.http.get<analysisModel>(this.baseurl + this.pathName+'/'+aysID);
    }

    add(item:analysisModel){
        return this.http.post(this.baseurl + this.pathName, item);
    }
    edit(aysID:number,item:analysisModel){
        return this.http.put<analysisModel>(this.baseurl + this.pathName+'/'+aysID,item);
    }
    delete(aysID:number){
        return this.http.delete(this.baseurl + this.pathName+'/'+aysID+'/'+NavigationComponent.selectedShopID.toString());
    }


}